import { DataBean } from "../DataBean";

export class OperationalState extends DataBean {


    public async getFixedAssetOperationalStateConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetOperationalStateConstants_Number", [id]);
    }

}